/**
 * Financing Options JavaScript
 * Handles interactive elements: collapsibles, FAQ accordion, smooth scrolling
 */

(function() {
  'use strict';

  /**
   * Initialize when DOM is ready
   */
  function init() {
    initCollapsibles();
    initFAQ();
    initSmoothScroll();
    initFormEnhancements();
  }

  /**
   * Initialize collapsible sections in financing cards
   */
  function initCollapsibles() {
    const collapsibles = document.querySelectorAll('.collapsible-section');
    
    collapsibles.forEach(section => {
      const header = section.querySelector('.collapsible-header');
      
      if (!header) return;
      
      header.addEventListener('click', () => {
        section.classList.toggle('active');
      });
    });
  }

  /**
   * Initialize FAQ accordion
   */
  function initFAQ() {
    const faqItems = document.querySelectorAll('.faq-item');
    
    faqItems.forEach(item => {
      const question = item.querySelector('.faq-question');
      
      if (!question) return;
      
      question.addEventListener('click', () => {
        const wasActive = item.classList.contains('active');
        
        // Close other items (optional - remove to allow multiple open)
        // faqItems.forEach(otherItem => {
        //   if (otherItem !== item) {
        //     otherItem.classList.remove('active');
        //   }
        // });
        
        // Toggle current item
        if (wasActive) {
          item.classList.remove('active');
        } else {
          item.classList.add('active');
        }
      });
    });
  }

  /**
   * Initialize smooth scrolling for anchor links
   */
  function initSmoothScroll() {
    const anchors = document.querySelectorAll('a[href^="#"]');
    
    anchors.forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        
        // Skip if href is just "#"
        if (href === '#') return;
        
        const target = document.querySelector(href);
        
        if (target) {
          e.preventDefault();
          
          // Calculate offset for sticky header
          const offset = 80; // Adjust based on your header height
          const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  /**
   * Form enhancements and validation
   */
  function initFormEnhancements() {
    const form = document.getElementById('financing-contact-form');
    
    if (!form) return;
    
    // Add novalidate to use custom validation
    form.setAttribute('novalidate', '');
    
    // Phone number formatting
    const phoneInput = document.getElementById('contact_phone');
    if (phoneInput) {
      phoneInput.addEventListener('input', formatPhoneNumber);
    }
    
    // Real-time validation
    const requiredFields = form.querySelectorAll('[required]');
    requiredFields.forEach(field => {
      field.addEventListener('blur', () => validateField(field));
      field.addEventListener('input', () => clearFieldError(field));
    });
    
    // Form submission
    form.addEventListener('submit', handleFormSubmit);
  }

  /**
   * Format phone number as user types
   */
  function formatPhoneNumber(e) {
    const input = e.target;
    let value = input.value.replace(/\D/g, '');
    
    if (value.length <= 3) {
      input.value = value;
    } else if (value.length <= 6) {
      input.value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
    } else {
      input.value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
    }
  }

  /**
   * Validate individual field
   */
  function validateField(field) {
    const value = field.value.trim();
    let errorMessage = '';
    
    if (field.hasAttribute('required') && !value) {
      errorMessage = 'This field is required';
    } else if (field.type === 'email' && value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        errorMessage = 'Please enter a valid email address';
      }
    } else if (field.type === 'tel' && value) {
      const phoneRegex = /^\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})$/;
      if (!phoneRegex.test(value.replace(/\D/g, ''))) {
        errorMessage = 'Please enter a valid phone number';
      }
    }
    
    if (errorMessage) {
      showFieldError(field, errorMessage);
      return false;
    } else {
      clearFieldError(field);
      return true;
    }
  }

  /**
   * Show field error
   */
  function showFieldError(field, message) {
    clearFieldError(field);
    
    field.classList.add('error');
    field.style.borderColor = '#dc2626';
    
    const errorEl = document.createElement('div');
    errorEl.className = 'field-error';
    errorEl.style.color = '#dc2626';
    errorEl.style.fontSize = '0.875rem';
    errorEl.style.marginTop = '0.25rem';
    errorEl.textContent = message;
    
    field.parentNode.appendChild(errorEl);
  }

  /**
   * Clear field error
   */
  function clearFieldError(field) {
    field.classList.remove('error');
    field.style.borderColor = '';
    
    const existingError = field.parentNode.querySelector('.field-error');
    if (existingError) {
      existingError.remove();
    }
  }

  /**
   * Handle form submission
   */
  function handleFormSubmit(e) {
    const form = e.target;
    const requiredFields = form.querySelectorAll('[required]');
    let isValid = true;
    
    // Validate all required fields
    requiredFields.forEach(field => {
      if (!validateField(field)) {
        isValid = false;
      }
    });
    
    if (!isValid) {
      e.preventDefault();
      
      // Focus first error field
      const firstError = form.querySelector('.error');
      if (firstError) {
        firstError.focus();
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      
      return false;
    }
    
    // If using Shopify's contact form, let it submit normally
    // Otherwise, you could handle with AJAX here
  }

  /**
   * Utility: Debounce function
   */
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  /**
   * Track scroll position for animations (optional enhancement)
   */
  function initScrollAnimations() {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    // Observe elements that should animate on scroll
    const animateElements = document.querySelectorAll('.finance-card, .faq-item');
    animateElements.forEach(el => observer.observe(el));
  }

  /**
   * Analytics tracking helper (optional)
   */
  function trackEvent(category, action, label) {
    // Google Analytics
    if (typeof gtag !== 'undefined') {
      gtag('event', action, {
        'event_category': category,
        'event_label': label
      });
    }
    
    // Facebook Pixel
    if (typeof fbq !== 'undefined') {
      fbq('trackCustom', action, {
        category: category,
        label: label
      });
    }
  }

  /**
   * Track CTA clicks
   */
  function initCTATracking() {
    const ctaButtons = document.querySelectorAll('.cta-button');
    
    ctaButtons.forEach(button => {
      button.addEventListener('click', function() {
        const buttonText = this.textContent.trim();
        const href = this.getAttribute('href');
        
        trackEvent('Financing', 'CTA Click', `${buttonText} - ${href}`);
      });
    });
  }

  // Initialize everything when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Optional: Initialize scroll animations
  // Uncomment if you want fade-in animations
  // if (document.readyState === 'loading') {
  //   document.addEventListener('DOMContentLoaded', initScrollAnimations);
  // } else {
  //   initScrollAnimations();
  // }

  // Optional: Track CTA clicks for analytics
  // if (document.readyState === 'loading') {
  //   document.addEventListener('DOMContentLoaded', initCTATracking);
  // } else {
  //   initCTATracking();
  // }

})();
